var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVolop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#717375"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.182 10.818a.63.63 0 0 0 .636-.623V2.533a.63.63 0 0 0-.636-.624.63.63 0 0 0-.637.624v7.662a.631.631 0 0 0 .637.623zm-3.182 0a.64.64 0 0 0 .636-.644V.644A.64.64 0 0 0 7 0a.64.64 0 0 0-.636.644v9.53a.64.64 0 0 0 .636.644z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.715 13.003c0 3.026-2.562 5.487-5.713 5.487-3.15 0-5.713-2.461-5.713-5.487V7.618c1.094.274 1.902 1.231 1.902 2.366v2.33c0 .34.289.619.644.619 1.564 0 2.735.555 3.299 1.563a.66.66 0 0 0 .87.252.607.607 0 0 0 .263-.837c-.713-1.275-2.045-2.04-3.788-2.188V1.891a.632.632 0 0 0-.645-.618.632.632 0 0 0-.644.618V7.24a3.9 3.9 0 0 0-2.546-.938.632.632 0 0 0-.644.619v6.082c0 3.708 3.14 6.724 7 6.724s7-3.016 7-6.724V3.815a.632.632 0 0 0-.644-.618.632.632 0 0 0-.644.618l.003 9.188z"
  }))));
}

export default SvgVolop;